import Vue from 'vue'
import RoutePoolPlugin from './src'
import router from '@/router'

Vue.use(RoutePoolPlugin, { router })
